import React, { useState, useEffect, useMemo } from 'react'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { locale } from 'devextreme/localization'

import TextBox from 'devextreme-react/text-box'
import SelectBox, { FieldAddons } from 'devextreme-react/select-box'

import { useSettingsUpdate } from 'hooks'
import { useIxAuth } from 'contexts/auth-context'
import { RootState } from 'slices'

import enFlag from 'assets/images/flags/en.png'
import deFlag from 'assets/images/flags/de.png'
//import bgFlag from 'assets/images/flags/bg.png'

import './lang-toggle.scss'

const languages = [
    {
        name: 'English',
        shortName: 'en',
        flagSrc: enFlag
    },
    {
        name: 'Deutsch',
        shortName: 'de',
        flagSrc: deFlag
    }/*,
    {
        name: 'Български',
        shortName: 'bg',
        flagSrc: bgFlag
    },*/
]

const IxItem = (data: any) => {
    const { name, shortName, flagSrc } = data
    return (
        <div className='ix-lang-toggle-item'>
            <img src={ flagSrc } alt={ shortName } />
            <div>{ name }</div>
        </div>
    )
}

const IxFieldIcon = (data: any) => {
    const { shortName, flagSrc } = data
    return (
        <img src={ flagSrc } alt={ shortName } />
    )
}


export const IxLangToggle = () => {
    const { i18n } = useTranslation()
    const [ value, setValue ] = useState(i18n.language)

    const { user } = useIxAuth()

    const updateSetting = useSettingsUpdate()
    const { LNR, statusLNR } = useSelector((state: RootState) => state.rights)
    const languagesFiltered = useMemo(() => (
        statusLNR !== 'loaded' || LNR === 999999 ? languages : languages.filter(lang => lang.shortName !== 'bg')
    ), [LNR, statusLNR])

    const handleChange = (e: any) => {
        const lang = e.value
        setValue(lang)
        locale(lang)
        i18n.changeLanguage(lang)

        if (user) {
            updateSetting('language', lang)
        }
    }

    useEffect(() => {
        setValue(i18n.language)
    }, [i18n.language])

    return (
        <React.Fragment>
            <SelectBox
                className='ix-lang-toggle'
                dataSource={languagesFiltered}
                valueExpr='shortName'
                displayExpr='name'
                defaultValue={i18n.language}
                value={value}
                itemRender={IxItem}
                onValueChanged={handleChange}
                width={150}
                acceptCustomValue={false}
                openOnFieldClick={true}
            >
                <FieldAddons beforeRender={IxFieldIcon} />
            </SelectBox>
        </React.Fragment>
    )
}
